import React from "react";
import { VERSION_WEB } from "../api/ApiService";


const Footers = () => {
    return (
        <div className="mt-auto">
            <FootersWeb />
        </div>
    );
}

export default Footers;




const FootersWeb = () => {
    return (
        <footer className="absolute w-full bg-white border-t border-gray-200 py-2.5">
            <div className="flex justify-between items-center px-5">
                <div />
                <p className="text-xs text-gray-500">
                    © {new Date().getFullYear()} Paseo La Galeria. Todos los derechos reservados. — v{VERSION_WEB}
                </p>
            </div>
        </footer>
    );
}
